import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IUser } from "../../../Pages/User/IUser";

export const ListSettingResetMockSlice = createSlice({
  name: "ListSettingResetMockSlice",
  initialState: {} as IReduxState<IUser[]>,
  reducers: {
    listSettingResetMock: (state) => {
      state.isLoading = true;
    },
    successlistSettingResetMock: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSettingResetMock: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSettingResetMockResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistSettingResetMock,
  listSettingResetMock,
  successlistSettingResetMock,
  clearSettingResetMockResponse,
} = ListSettingResetMockSlice.actions;

export default ListSettingResetMockSlice.reducer;
